import { useEffect, useRef, useState } from "react";
import InterAppCom from "../utils/interAppCom";
import turnChatConfigToWebAppConfig from "../utils/basicConfig";

const ChatPreview = ({ configs, knowledge }) => {
  const frameRef = useRef(null); // Assuming you have a ref to your iframe
  const [webAppCommunicator, setWebAppCommunicator] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [webAppConfig, setWebAppConfig] = useState({});

  useEffect(() => {
    setWebAppConfig(
      turnChatConfigToWebAppConfig({
        webappConfig: configs || {},
        knowledge: knowledge || "",
      })
    );
  }, [configs, knowledge, setWebAppConfig]);

  useEffect(() => {
    if (frameRef.current) {
      const iframe = frameRef.current;
      const iframeWindow = iframe.contentWindow;
      const iframeDocument = iframe.contentDocument;

      if (iframeDocument.readyState === "complete") {
        setTimeout(() => {
          setIsReady(true);
        }, 100);
      } else {
        iframeWindow.addEventListener("load", () => {
          setTimeout(() => {
            setIsReady(true);
          }, 100);
        });
      }
    }
  }, [frameRef, setIsReady]);

  useEffect(() => {
    if (!isReady) return;
    // Initialize the InterAppCom communicator
    const communicator = new InterAppCom(
      "https://devwebapp.alloreview.com", // The target origin
      "https://devwebapp.alloreview.com", // The base URL (can be different if needed)
      frameRef.current.contentWindow, // The target window
      (data) => {
        console.log("Received data from the iframe", data);
      }
    );
    setWebAppCommunicator(communicator);

    return () => {
      communicator.cleanUp();
    };
  }, [frameRef, isReady]); // This effect runs whenever `configs` changes

  useEffect(() => {
    if (webAppCommunicator && webAppCommunicator.sendMessage) {
      console.log("sending update to iframe", webAppConfig);
      webAppCommunicator.sendMessage({
        action: "update",
        detail: {
          config: webAppConfig,
        },
      });
    }
  }, [webAppConfig, webAppCommunicator]);

  return (
    <div className="bg-gray-100 h-full">
      <iframe
        ref={frameRef}
        src="https://devwebapp.alloreview.com/live-preview"
        title="web-app-simulation"
        width="100%"
        height="100%"
        id="frame"
        allow="microphone"
        style={{ pointerEvents: "auto", border: "none" }}
        onLoad={() => {
          console.log("iframe loaded");
          webAppCommunicator.sendMessage({ action: "hand-check" });
        }}
      ></iframe>
    </div>
  );
};

export default ChatPreview;
